$(document).ready(function () {
    $(".content").slice(0, 9).show();
    $(document).on("click", "#blog-post-loadMore", function (e) {
        e.preventDefault();
        $(".content:hidden").slice(0, 9).show();
        if ($(".content:hidden").length == 0) {
            $(this).fadeOut('slow');
            $("#blog-post-loadMore").text("No Content").addClass("noContent");
            $("#blog-post-loadMore").css("pointer-events", "none");
        }
        $('html,body').animate({
            scrollTop: $(this).offset().top - 500
        }, 1000);
    });
    $(".rel-article-content").slice(0, 3).show();
    $("#rel-article-loadMore").on("click", function (e) {
        e.preventDefault();
        $(".rel-article-content:hidden").slice(0, 3).show();
        if ($(".rel-article-content:hidden").length == 0) {
            $("#rel-article-loadMore").text("No Content").addClass("noContent");
            $("#rel-article-loadMore").css("pointer-events", "none");
        }
        $('html,body').animate({
            scrollTop: $(this).offset().top - 500
        }, 1000);
    });
    if ($('.rel-article-content').length > 3) {
        $("#rel-article-loadMore").show();
    } else {
        $("#rel-article-loadMore").hide();
    }
    if ($('.content').length > 3) {
        $("#blog-post-loadMore").show();
    } else {
        $("#blog-post-loadMore").hide();
    }
});